<template>
  <div class="home">
    <h1>🧙‍♂️ hugohil is an independent creative technologist, technical artist and programmer.</h1>
    <p>🤳 he designs && builds modular tools && parametric systems for interactive experiences.</p>
    <p>🚧 he conducts research && development in the fields of immersive experiences, digital innovation, generative design, new medias && ...</p>
    <p>👨‍🏫 he teaches at the <a href="http://www.ecole-estienne.paris/formation/dsaa-design-et-creation-numerique/presentation/" target="_blank">Ecole Estienne</a>, where he helps students in their diploma projects.</p>
    <!-- <p>🤯 he's also half of fubar, an audiovisual duo that experiments with pixels, sound && real life.</p> -->
    <p>🤓 he is named Hugo Hilaire, lives in France && studied visuals arts && programming in Paris && Montréal.</p>
    <p>📱 he has a <a href="https://github.com/hugohil" target="_blank">github</a>, <a href="https://www.instagram.com/hugohil/" target="_blank">instagram</a> && a <a href="https://www.linkedin.com/in/hugohil/" target="_blank">linkedin</a> account.</p>
    <br>
    <p>🫵 you can contact him on <a href="https://www.instagram.com/hugohil/" target="_blank">instagram</a> or shoot an email at hugo [at] hugohil [dot] tech</p>
  </div>
</template>

<script>
export default {
  name: 'home',
  metaInfo () {
    return {
      title: `hugohil — creative technologist`,
      meta: [
        { name: 'description', content: '🧙‍♂️ hugohil is an independent creative technologist, designs && builds modular tools && parametric systems for digital experiences, conducts research && development in the fields of immersive experiences, digital innovation, generative design, new medias' }
      ]
    }
  }
}
</script>

<style lang="scss">
  .home {
    padding: 0 2em;
    margin: 3em 0;
    max-width: 960px;
    line-height: 1.5;

    h1 {
      font-weight: 400;
      font-style: normal;
    }
    h1, p {
      font-size: 16px;
      margin: .5em 0;

      &:before {
        content: '*';
        font-weight: 500;
        margin: 0 .5em;
      }
    }
  }
</style>
